import ACTION_TYPES from '../../constants/actionTypes';
import BOAPlansStub from '../../constants/planResponseStub';
import merge from 'lodash/merge';

export default {
  policies(state = {}, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_POLICIES_SUCCESS:
        return {
          ...state,
          ...action.payload.reduce((acc, policy) => {
            if (policy.vertical.code === 'chubb_boa') {
              // XXX: Use stubbed plans response until second plan is added to BOA
              policy.plan = merge({}, BOAPlansStub.plans[0], policy.plan);
            }
            acc[policy.id] = policy;
            return acc;
          }, {}),
        };
      case ACTION_TYPES.GET_POLICY_SUCCESS:
      case ACTION_TYPES.SUBMIT_POLICY_NUMBER_SUCCESS:
        if (action.payload.vertical.code === 'chubb_boa') {
          // XXX: Use stubbed plans response until second plan is added to BOA
          action.payload.plan = merge(
            {},
            BOAPlansStub.plans[0],
            action.payload.plan
          );
        }
        return {
          ...state,
          [action.payload.id]: action.payload,
        };
      case ACTION_TYPES.LOGIN:
      case ACTION_TYPES.LOGOUT:
      case ACTION_TYPES.SAVE_ANONYMOUS_TOKEN:
        return {};
      default:
        return state;
    }
  },

  isFetchingPolicies(state = false, action) {
    switch (action.type) {
      case ACTION_TYPES.GET_POLICIES:
      case ACTION_TYPES.GET_POLICY:
        return true;
      case ACTION_TYPES.GET_POLICIES_SUCCESS:
      case ACTION_TYPES.GET_POLICIES_FAILURE:
      case ACTION_TYPES.GET_POLICY_SUCCESS:
      case ACTION_TYPES.GET_POLICY_FAILURE:
        return false;
      default:
        return state;
    }
  },
};
